import { SessionStorageService } from "."

const UserLanguageService = {
  setLanguageCode: (languageCode: string): void => {
    SessionStorageService.set("userLanguage", languageCode.toLowerCase())
  },
  
  getLanguageCode: (): string => {
    return SessionStorageService.get("userLanguage") || "";
  }
}

export default UserLanguageService;
